import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  getOrderInfo,
  getRequestInfo,
  rejectRequest,
  sendUserNotification,
} from "../../../../utilities";
import { useNavigate } from "react-router-dom";
import DatePicker from "react-datepicker";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { Button } from "@mui/material";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import NumbersIcon from "@mui/icons-material/Numbers";
import WorkIcon from "@mui/icons-material/Work";
import HomeIcon from "@mui/icons-material/Home";
import {
  RequestActionShell,
  SectionLabel,
  Field,
  NotesInput,
  datePickerClass,
} from "../../../../components/WindowDoor/Requests/RequestActionUI";

const iconProps = { fontSize: 16 };

const RejectRequest = () => {
  const { id } = useParams();
  const [notes, setNotes] = useState("");
  const navigate = useNavigate();
  const [altDate, setAltDate] = useState([]);
  const [dateSelected, setDate] = useState(new Date());
  const [data, setData] = useState("");
  const [requestData, setReqData] = useState("");

  useEffect(() => {
    getOrderInfo(id, setData);
    getRequestInfo(id, setReqData);
  }, []);

  const handleRemoveItem = (removeTarget) => {
    const date = removeTarget;
    setAltDate(altDate.filter((item) => item !== date));
  };

  const handleReject = () => {
    rejectRequest(id, notes, altDate);
    sendUserNotification(
      requestData?.requestEmail,
      "System",
      `Your Request For Order #${requestData.salesOrder} Has Been Rejected, please check email to accept alternative date.`,
      "Delivery Request Rejected"
    );
    navigate("/windowdoor/admin/requestlist");
  };

  return (
    <RequestActionShell
      title="Reject Request"
      accent="red"
      id={id}
      showError={data.error}
      footer={
        <Button variant="contained" color="error" onClick={handleReject}>
          Reject Request
        </Button>
      }
    >
      <div className="space-y-6">
        <div>
          <SectionLabel>Order details</SectionLabel>
          <div className="grid grid-cols-1 gap-3 sm:grid-cols-3">
            <Field
              icon={<PersonOutlineIcon sx={iconProps} />}
              label="Customer"
              value={data.Customer}
            />
            <Field
              icon={<NumbersIcon sx={iconProps} />}
              label="Order Number"
              value={data.OrderNumber}
            />
            <Field
              icon={<WorkIcon sx={iconProps} />}
              label="Job Ref"
              value={data["Job Ref"]}
            />
            <div className="sm:col-span-3">
              <Field
                icon={<HomeIcon sx={iconProps} />}
                label="Deliver To"
                value={data["Deliver To"]}
              />
            </div>
          </div>
        </div>

        <div>
          <SectionLabel>Alternative dates</SectionLabel>
          <p className="app-muted -mt-2 mb-3 text-xs">
            Pick each date you can offer — the rejection email gives the
            requester a button for each one.
          </p>
          <DatePicker
            selected={dateSelected}
            minDate={new Date()}
            onChange={(date) => {
              setAltDate((altDate) => [
                ...altDate,
                date.toLocaleDateString("en-US"),
              ]);
              setDate(date);
            }}
            className={datePickerClass}
          />

          {altDate.length > 0 && (
            <ul className="mt-3 flex flex-wrap gap-2">
              {altDate.map((item, index) => (
                <li
                  key={index}
                  className="app-surface inline-flex items-center gap-1 rounded-full border py-0.5 pl-3 pr-1 text-sm font-medium tabular-nums"
                >
                  <span>{item}</span>
                  <button
                    type="button"
                    onClick={() => handleRemoveItem(item)}
                    aria-label={`Remove ${item}`}
                    className="inline-flex h-7 w-7 items-center justify-center rounded-full text-rose-600 transition hover:bg-rose-500/10 dark:text-rose-400"
                  >
                    <DeleteForeverIcon sx={{ fontSize: 18 }} />
                  </button>
                </li>
              ))}
            </ul>
          )}
        </div>

        <NotesInput value={notes} onChange={(e) => setNotes(e.target.value)} />
      </div>
    </RequestActionShell>
  );
};

export default RejectRequest;
